import type { NovaV1Assignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const NOVA_V1_CONTROL = 'control';
const NOVA_V1_VARIANT1 = 'variant1';
const NOVA_V1_VARIANT2 = 'variant2';
const NOVA_V1_VARIANT3 = 'variant3';

export const novaV1Selector = (state: State) => {
	return (selectAssignment(state, ['novaV1']) ?? null) as NovaV1Assignment;
};

export const isNovaV1Control = (state: State): boolean => {
	return novaV1Selector(state) === NOVA_V1_CONTROL;
};

export const isNovaV1Variant1 = (state: State): boolean => {
	return novaV1Selector(state) === NOVA_V1_VARIANT1;
};

export const isNovaV1Variant2 = (state: State): boolean => {
	return novaV1Selector(state) === NOVA_V1_VARIANT2;
};

export const isNovaV1Variant3 = (state: State): boolean => {
	return novaV1Selector(state) === NOVA_V1_VARIANT3;
};
